import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import AMFacilities from './AMFacilities';

function App() {
  return (
    <HelmetProvider>
      <div className='App'>
        <AMFacilities />
      </div>
    </HelmetProvider>
  );
}

export default App;
